import React from 'react'
import star from '../assets/images/star.svg'
import starEmpty from '../assets/images/star-empty.svg'
import Button from './button'

const Stars = ({ starCount }) => {
  if (starCount >= 0) {
    return (
      <div className='stars'>
        <img
          src={starCount === 0 ? starEmpty : star}
          alt='Star'
          width='48'
          height='48'
        />
        <img
          src={starCount > 1 ? star : starEmpty}
          alt='Star'
          width='64'
          height='64'
        />
        <img
          src={starCount > 2 ? star : starEmpty}
          alt='Star'
          width='48'
          height='48'
        />
      </div>
    )
  }
  return <></>
}

const Alert = ({ text, subText, show, starCount, score, buttons, html }) => {
  if (!show) return <></>

  return (
    <div className='alert animated'>
      <Stars starCount={starCount} />
      <div className='content'>
        {text && <h1>{text}</h1>}
        {subText && <p>{subText}</p>}
        {html && <p>{html}</p>}
        {score >= 0 && (
          <span
            className='text-bg user-score d-inline-flex px-4 py-1'
            title='Score'
          >
            <img src={star} width='24' height='24' alt='star' />
            Score: {score}
          </span>
        )}
        {buttons?.length > 0 && (
          <div className='buttons'>
            {buttons.map((button, index) => {
              return (
                <Button
                  onClick={button.onClick}
                  color={button.color}
                  key={index}
                >
                  {button.text}
                </Button>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default Alert
